import { Component, computed, input } from '@angular/core';
import { InstitutionPerson } from '../../../api/app-types/institution.app';
import { TranslocoPipe } from '@jsverse/transloco';
import { LvrSimplePanel } from '../../../core/components/simple-panel/simple-panel';

@Component({
	selector: 'lvr-institution-persons-item',
	imports: [TranslocoPipe, LvrSimplePanel],
	templateUrl: './institution-persons-item.html',
	styleUrl: './institution-persons-item.scss',
})
export class InstitutionPersonsItem {
	public readonly person = input<InstitutionPerson>();
	public readonly institutionName = input<string>('');
	public readonly personName = computed(() =>
		this.person()?.firstName
			? `${this.person()?.name ?? ''}, ${this.person()?.firstName ?? ''}`.trim()
			: `${this.person()?.name ?? ''}`.trim(),
	);
}
